import {AuthUserData} from "../types/authentication";

export const fetchUserData = async (token: string): Promise<AuthUserData | null> => {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENTRYPOINT}me`, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
    });

    if (!response.ok) {
        if (response.status === 401 || response.status === 403) {
            return null;
        }

        throw new Error(`Unable to load /me profile (status ${response.status})`);
    }

    return await response.json() as AuthUserData;
};
